<template>
    <div id="main">
        <div class="page page-container">
            <alert-container :messages="msgs" />
            <div class="nova-linha-produto">
                <h1 class="title">
                    {{ $t('linha-produto') }}:
                    {{ $t('nova-linha-produto') }}
                </h1>
                <div class="form-columns-fit mt-5">
                    <div class="columns is-flex-wrap">
                        <div class="column is-4">
                            <v-input
                                :id="generateId(1)"
                                ref="idErpInput"
                                v-model="lp.idlinhaprodutoerp"
                                placeholder="placeholder-preencha"
                                :maxlength="30"
                                title="codigo"
                                uppercase
                                required
                                :invalid="!lp.idlinhaprodutoerp"
                                tooltipLabel="cod-ref"
                            />
                        </div>
                        <div class="column is-4">
                            <v-input
                                :id="generateId(2)"
                                v-model="lp.descricao"
                                :placeholder="'descricao-da-linha-placeholder'"
                                :maxlength="100"
                                :title="'descricao-da-linha-produto'"
                                :msg="'msg-campo-obrigatorio'"
                                :invalid="!lp.descricao"
                                ref="descricaoInput"
                                required
                                tooltipLabel="info-descricao-generica"
                            />
                        </div>
                        <div class="column is-4">
                            <vs-select
                                :id="generateId(3)"
                                ref="gpSelect"
                                :title="'grupo-linha-produto'"
                                v-model="gruposelected"
                                :placeholder="'grupo-do-sub-grupo-placeholder'"
                                required
                                disabled
                                tooltipLabel="info-grupo-linhaproduto"
                            />
                        </div>
                        <div class="column is-6">
                            <vs-select
                                :id="generateId(4)"
                                ref="subgrupoInput"
                                :title="'sub-grupo-linha-produto'"
                                v-model="subgruposelected"
                                :placeholder="'sub-grupo-linha-placeholder'"
                                disabled
                                required
                                tooltipLabel="info-subgrupo-linhaproduto"
                            />
                        </div>
                        <div class="column is-6">
                            <vss-select
                                :id="generateId(5)"
                                ref="situacaoSelect"
                                v-model="situacao"
                                :disabled="!isUpdate"
                                tooltipLabel="info-situacao-generica"
                                title="situacao"
                            />
                        </div>
                    </div>
                </div>
                <div class="form-buttons">
                    <button class="delete-btn" type="button" @click="voltar">
                        {{ $t('voltar') }}
                    </button>
                    <button
                        v-if="(!isUpdate && permissao.create) || (isUpdate && permissao.update)"
                        class="save-btn"
                        type="button"
                        @click="saveLinhaPergunta()"
                        :disabled="isSaving"
                    >
                        {{ $t('salvar') }}
                        <button-loader :isSaving="isSaving" />
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import LinhaProdutoService from '@/services/LinhaProdutoService';
import SubGrupoProdutoService from '@/services/SubGrupoProdutoService';
import GrupoProdutoService from '@/services/GrupoProdutoService';
import LinhaValidation from '@/services/validations/LinhaValidation';
import Message from '@/models/Message';

export default {
    props: {
        gruposelected: {},
        subgruposelected: {},
    },
    data() {
        return {
            service: null,
            gruposervice: null,
            subgruposervice: null,
            validation: null,
            isSaving: false,
            lp: {
                situacao: 1,
                subgrupoproduto: null,
                nomeunico: null,
            },
            editable: false,
            title: '',
            msgs: [],
            grupo: null,
            grupos: [],
            subgrupo: null,
            subgrupos: [],
            loadGroup: false,
            loadSubGroup: false,
            canSelectSubGrupo: false,
            canSelectGrupo: false,
            situacao: { label: this.$t('ativo'), id: 1 },
            situacoes: [
                { label: this.$t('ativo'), id: 1 },
                { label: this.$t('inativo'), id: 0 },
            ],
            isUpdate: false,
            // @84562 - Adicionado variável para verificar a origem da rota
            // Esta variável é utilizada sempre que for verificado se a origem da rota é vendas ou promotor
            isVenda: 'vendas' === this.$route.meta.contexto ? true : false,
            empresas: [],
            sort: {
                order: 'desc',
                column: 'DESCRICAO',
            },
        };
    },
    created() {
        if (this.lp != null && this.lp != {}) {
            this.editable = true;
        }

        this.service = new LinhaProdutoService(this.$http, this.$router);
        (this.gruposervice = new GrupoProdutoService(this.$http, this.$router)),
            (this.subgruposervice = new SubGrupoProdutoService(this.$http, this.$router)),
            (this.validation = new LinhaValidation(this.msgs)),
            (this.permissao = this.isVenda
                ? this.hasPermissionAccess('vendas', 'produtos', 'ven-produto-linha')
                : this.hasPermissionAccess('promotor', 'cadastros', 'linhas'));
        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'linhas-produto' },
            });
        } else {
            this.isUpdate = this.$route.params.id ? true : false;
            if (!this.isUpdate && !this.permissao.create) {
                this.$router.push({
                    name: 'acesso-nao-permitido',
                    params: { tela: 'linha-produto' },
                });
            }
        }
    },
    mounted() {
        this.$refs.descricaoInput.$refs.typed.focus();
    },
    methods: {
        generateId(numberId) {
            return this.$route.name + '-' + numberId;
        },
        voltar() {
            this.$emit('fecharModal', 'linha-produto', 'close', 1);
        },
        saveLinhaPergunta() {
            this.isSaving = true;
            this.lp.subgrupoproduto = {
                idsubgrupoproduto: this.subgruposelected.id,
            };
            this.lp.grupoproduto = { idgrupoproduto: this.gruposelected.id };
            this.lp = this.mapTosave(this.lp);
            if (this.validation.validate(this.lp, this.$refs)) {
                this.service
                    .save(this.lp)
                    .then((body) => {
                        if (body.content) {
                            let msg = 'msg-linha-salva';
                            if (this.lp.id) {
                                msg = 'msg-linha-editada';
                            }
                            this.lp = body.content;
                            this.msgs.push(new Message('success', msg, true));

                            setTimeout(() => {
                                this.$emit('fecharModal', 'linha-produto', 'save', 1, this.lp);
                            }, 1000);
                        } else {
                            this.isSaving = false;
                            let message = body.message;
                            if (message && this.$te(message)) {
                                if (message == 'msg-codigo-duplicado-n') {
                                    this.msgs.push(
                                        new Message(
                                            'alert',
                                            this.$t(message, { n: this.lp.idlinhaprodutoerp }),
                                            true,
                                            false
                                        )
                                    );
                                } else {
                                    this.msgs.push(new Message('alert', message, true));
                                }

                                return;
                            }

                            this.msgs.push(
                                new Message('error', 'msg-problema-realizar-acao', true)
                            );
                        }
                    })
                    .catch((e) => {
                        this.msgs.push(new Message('error', 'msg-problema-realizar-acao', true));
                        this.isSaving = false;
                    });
            } else {
                this.isSaving = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import './mixins.scss';

#main {
    padding: 0 20px;
    height: auto;
}
.page {
    position: relative;
    margin-bottom: 80px;

    .nova-linha-produto {
        position: relative;
        width: 100%;
        margin-bottom: 20px;
        height: 100%;
        padding-top: 0;
        > h1 {
            padding-top: 20px;
            margin-bottom: 40px;
        }
    }
}

.nova-linha-produto .center {
    width: 100%;
    left: 0;
    transform: translateX(0);
    margin: 0;
    box-sizing: border-box;
    position: initial;
    padding-bottom: 20px;
}

.form-buttons {
    right: 0;
}

@media only screen and (min-width: 760px) {
    nav.breadcrumb {
        margin-right: 410px;
    }
}

.nova-linha-produto .form {
    // display: block;
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    border-radius: 2px;
    text-align: left;

    .descricao-input,
    .grupo-input,
    .sub-grupo-input,
    .situacao-input {
        width: 49.5%;
        @include default-size-column;
    }
}

h1.title {
    margin-right: 530px;
}
</style>
